import { CoreApi, Product, ProductType } from '@inter-ikea-storageone/range';
import { getInteriorsInLoftBedCabinet, getInteriorsInLoftBedDesk } from '../utils/loftbed';
import { HierarchyUtils } from '@inter-ikea-core/core';
import { LoftBedComponent } from '@inter-ikea-storageone/range-smastad';

export const noInteriorsInLoftBedCabinet = (coreApi: CoreApi) => {
  const selectedEntity = coreApi.entities.findSelectedEntity();
  if (
    !selectedEntity ||
    !coreApi.entities.isProductType(selectedEntity, ProductType.SMASTAD_LOFT_BED)
  ) {
    return false;
  }
  return getInteriorsInLoftBedCabinet(selectedEntity).length === 0;
};

export const noInteriorsInLoftBedDesk = (coreApi: CoreApi) => {
  const selectedEntity = coreApi.entities.findSelectedEntity();
  if (
    !selectedEntity ||
    !coreApi.entities.isProductType(selectedEntity, ProductType.SMASTAD_LOFT_BED)
  ) {
    return false;
  }
  return getInteriorsInLoftBedDesk(selectedEntity).length === 0;
};

export const furnitureSelected = (product: Product, coreApi: CoreApi) => {
  switch (product.type) {
    case ProductType.SMASTAD_BENCH_WITH_DRAWER_ASM:
      const benchesInScene = coreApi.entities.getByProductType(ProductType.SMASTAD_BENCH);
      return benchesInScene.some(bench =>
        HierarchyUtils.children(bench).find(child =>
          coreApi.entities.isProductType(child, ProductType.SMASTAD_BENCH_DRAWER)
        )
      );
    case ProductType.SMASTAD_BENCH:
      const benchesInScene2 = coreApi.entities.getByProductType(ProductType.SMASTAD_BENCH);
      return benchesInScene2.some(
        bench =>
          !HierarchyUtils.children(bench).find(child =>
            coreApi.entities.isProductType(child, ProductType.SMASTAD_BENCH_DRAWER)
          )
      );
    case ProductType.SMASTAD_CHANGING_TABLE_W_DRAWERS_ASM:
      return coreApi.entities.getByProductType(ProductType.SMASTAD_CHANGING_TABLE).length > 0;
    case ProductType.SMASTAD_DESK_W_DRAWERS_ASM:
      return coreApi.entities.getByProductType(ProductType.SMASTAD_DESK).length > 0;
    case ProductType.SMASTAD_LOFT_BED_ASM:
      const loftBedsInScene = coreApi.entities.getByProductType(ProductType.SMASTAD_LOFT_BED);
      return loftBedsInScene.some(loftBed => {
        const orientations = loftBed.getComponent<LoftBedComponent>(LoftBedComponent.id);
        return (
          orientations?.mirrored === product.meta?.loftBedOrientation?.mirrored &&
          orientations?.inwardDesk === product.meta?.loftBedOrientation?.['inward-desk'] &&
          orientations?.inwardCabinet === product.meta?.loftBedOrientation?.['inward-cabinet']
        );
      });

    default:
      return false;
  }
};
